import React from "react";
import Marquee from "react-fast-marquee";
const TextSlider = () => {
  return (
    <div className='text-slider-section overflow-hidden bg-neutral-600 py-8'>
      <div className='text-slider d-flex align-items-center gap-4'>
        <Marquee
          speed={150}
          pauseOnHover={true}
          className='Marquee_text-slider'
        >
          <div className='d-flex align-items-center flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' className='w-20 h-20' />
            </span>
            <h4 className='text-white text-sm flex-grow-1 mb-0 fw-medium'>
              Online & Offline Classes Available
            </h4>
          </div>
          <div className='d-flex align-items-center flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' className='w-20 h-20' />
            </span>
            <h4 className='text-white text-sm flex-grow-1 mb-0 fw-medium'>
             Online & Offline Classes Available
            </h4>
          </div>
          <div className='d-flex align-items-center flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' className='w-20 h-20' />
            </span>
            <h4 className='text-white text-sm flex-grow-1 mb-0 fw-medium'>
             Online & Offline Classes Available
            </h4>
          </div>
          <div className='d-flex align-items-center flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' className='w-20 h-20' />
            </span>
            <h4 className='text-white text-sm flex-grow-1 mb-0 fw-medium'>
              Online & Offline Classes Available
            </h4>
          </div>
          <div className='d-flex align-items-center flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' className='w-20 h-20' />
            </span>
            <h4 className='text-white text-sm flex-grow-1 mb-0 fw-medium'>
            Online & Offline Classes Available
            </h4>
          </div>
          <div className='d-flex align-items-center flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' className='w-20 h-20' />
            </span>
            <h4 className='text-white text-sm flex-grow-1 mb-0 fw-medium'>
              {" "}
              Online & Offline Classes Available
            </h4>
          </div>
        </Marquee>
      </div>
    </div>
  );
};

export default TextSlider;
